import React, { VFC, useEffect, useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';
import { Heading } from './Elements/Heading';
import WelcomeBoquet from '@/assets/img/welcome-bouquet.png';
import { ReactComponent as Tick } from '@/assets/img/tick-mark.svg';
import { useAuth } from '@/lib/auth';
import storage from '@/utils/storage';
import { useOnBoardingDetails } from '@/features/events/api/getOnBoardingDetails';
import { isMobile } from 'react-device-detect';
import appCompoLoading from '@/assets/animation/loading.json';
import Lottie from 'lottie-react';
import WelcomeConfeetti from '@/assets/animation/welcome-conffeti.json';
import { useTranslation } from 'react-i18next';

type StepProps = {
  selected?: boolean;
  title: string;
  description: string;
  navigation: string;
};
const InviteDialog: VFC<{
  open: boolean;
  onClose: () => void;

}> = ({ open, onClose }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const useGetOnBookingDetails = useOnBoardingDetails();
  const [onBoardingDetails, setOnBoardingDetails] = useState<any>();
  const animationRef = useRef<any>(null);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    fetchOnBoardingDetails();
  }, []);
  const fetchOnBoardingDetails = async () => {
    const res = await useGetOnBookingDetails.mutateAsync({ stepId: 1 });
    setOnBoardingDetails(res);
  };
  const WelcomeStep = ({ selected, title, description, navigation }: StepProps) => {
    return (
      <div className={`step ${selected ? 'selected' : 'not-selected'}`}>
        <div className="left-section">
          <span className="tick">{selected && <Tick />}</span>
          <Heading size="sm" title={title} description={description} />
        </div>
        <div className="right-section" onClick={() => { navigate(navigation), storage.clearKey('showCongratulations'); }}>
          {isMobile ? <span className={selected ? 'completed-setup' : "get-started"}>{selected ? t('Done') : t('Start')}</span> : <span className={selected ? 'completed-setup' : "get-started"}>{selected ? t('Completed') : t('Get Started')}</span>}

        </div>
      </div>
    );
  };

  React.useEffect(() => {
    if (animationRef.current) {
      animationRef.current.setSpeed(0.5);
    }
  }, []);

  return (
    <>
      <Modal show={open} onHide={onClose} className="petsked-modal-dialog welcome-dialog">

        <Lottie lottieRef={animationRef} className='welcome-conffeeti' animationData={WelcomeConfeetti} loop={false} />
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>

          <div className="image-holder">
            <img src={WelcomeBoquet} />
          </div>

          <Heading
            size="lg"
            title={t("Welcome aboard!")}
            alignText="center"
            description={t("Congratulations! you are finally ready, have a look around")}
          />
          <div className="progress-loader bar-50"></div>
          <div className="steps">

            {useGetOnBookingDetails?.isLoading ? <div className="h-full w-full flex items-center justify-center">
              <Lottie className="hw-30" animationData={appCompoLoading} />
            </div> : <>{onBoardingDetails?.progress.map((item: any) => {
              return (
                <WelcomeStep
                  selected={item?.isComplete}
                  title={item?.longTitle}
                  description={item?.description}
                  navigation={item?.actionUrl}
                />
              )
            })}</>}
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
};

export default InviteDialog;
